module.exports = __webpack_public_path__ + "img/ls3-engine.6985ced5.jpg";